import { OrderDetail } from '@/shared/model/order/order-detail.model';
import { Restaurant } from '@/shared/model/restaurant.model';
import { IRestaurantMenuStore } from './types';

export const state: IRestaurantMenuStore = {
  restaurant: new Restaurant(),
  isDeliver: false,
  orderDetail: new OrderDetail(),
};
